module.exports =
  '_GROUP_EVENT':
    'TITLE_CREATE': 'Create Event'
    'CUSTOMIZE_EVENT': 'イベントのカスタマイズ'
    'ADD_COVER_IMAGE': 'ここのカバー写真を追加できます'
    'SELECT_PHOTO': '写真を選択'
    'UPLOAD_PHOTO': '写真をアップロード'
    'CREATE_TITLE': 'イベントを作成'
    'EVENT_NAME': 'イベント名'
    'PERIOD_NAME': '期間'
    'START_DATE': '開始日'
    'END_DATE': '終了日'
    'VALID_DATE': '日付指定を見直してください。'
    'LOCATION': '場所'
    'DESCRIPTION': '説明'
    'CANCEL': 'キャンセル'
    'SAVE': '保存'
    'PARTICIPANTS' : '参加'
    'NONPARTICIPANTS': '不参加'
    'CREATE_EVENT': '新規イベント作成'
    'DELETE_EVENT': 'イベントを削除'
    'EVENT_LIST': 'イベント一覧'
    'SELECT_SCORE_CARD': '提出するスコアカードを選択'
    'VIEW_RANK': 'このイベントのランキングを見る'
    'LIST_SUBMITTED_SCORE': '提出済スコアカード'
    'DELETE': '削除'
    'SUBMIT': '提出する'
    'SUBMITTED': '提出済み'
    'CONFIRM_MESS': '削除してよろしいですか？'
    'VIEW_DETAIL': '詳細を見る'
    'CLOSE_DETAIL': '閉じる'
    'AVG_SCORE_RANK': '平均スコアランキング'
    'AVG_PUTT_RANK': '平均パットランキング'
    'PER_ON_RATE_RANK': 'パーオン率ランキング'
    'BIRDIE_RATE_RANK': 'バーディ率ランキング'
    'PER_RATE_RANK': 'パー率ランキング'
    'SUBMIT_DELETE_SCORCARD': 'スコアカード提出・削除'
    'OVERALL_SCORE_ANALYSIS': '全体のスコア分析'
    'SCORE_ANALYSIS': 'このラウンドのスコア分析'
    'FILTER_PERIOD': '対象期間'
    'FILTER_COURSE': '対象コース'
    'FILTER_STATUS': 'ステータス'
    'FILTER': '絞り込み'
    'FILTER_PC': '表示条件を絞り込む'
    'FILTER_CLOSE': '閉じる'
    'FILTER_PERIOD_ALL': '全期間'
    'FILTER_PERIOD_THREE_MONTH': '直近3ヶ月'
    'FILTER_PERIOD_SIX_MONTH': '直近6ヶ月'
    'FILTER_COURSE_ALL': '全コース'
    'FILTER_STATUS_ALL': '全て'
    'FILTER_STATUS_DONE': '提出済み'
    'FILTER_STATUS_NOTYET': '未提出'
    'FILTER_MODAL_HEADER': '対象コースの選択'
    'FILTER_MODAL_FOOTER': '決定'
    'FILTER_BY_CONDITION': 'この条件で絞り込む'
    'FILTER_SELECT_COURSE': '  コースを選択  >   '
    'CROP':
      'TITLE': 'トリミング'
      'CANCEL': 'キャンセル'
      'DONE': '完了'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-event/i18n/ja.coffee